import React, { Component } from 'react';
import { Col, Label, InputGroupText, InputGroupAddon } from "reactstrap";
import Checkbox from '../components/Checkbox'

export default class CheckboxField extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checkboxValue: !!this.props.ativo
        }

        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(event) {
        this.setState({
            checkboxValue: !this.state.checkboxValue
        }, () => {
            this.props.onClick(this.state.checkboxValue)
        })
    }

    componentDidUpdate(prevProps) {
        //Para algumas páginas é necessário esperar que o valor retornado pelo serviço seja retornado
        //Até lá um valor placeholder pode ter sido incluso ao this.props.ativo
        if (prevProps.ativo !== this.props.ativo) {
            this.setState({
                checkboxValue: this.props.ativo
            })
        }
    }

    render() {
        return (
            <Col className={`form-checkboxfield ${this.props.className || ''}`}
                 xs={this.props.xs || 'auto'}
                 sm={this.props.sm || 'auto'}
                 md={this.props.md || 'auto'}
                 lg={this.props.lg || 'auto'}
                 xl={this.props.xl || 'auto'} >
                {this.props.titulo ? <Label>{this.props.titulo}</Label> : this.props.noTitle ? "" : <Label className="checkboxfield--no-label">empty</Label>}
                <InputGroupText className={`
                    ${this.props.widthAuto ? "d-flex align-itens-center justify-content-start checkboxfield--group-widthauto" : "checkboxfield--group"}
                    ${this.props.backgroundWhite && ' background-white'}
                    `}
                >
                    <span className="checkboxfield--text d-flex justify-content-start pl-2">
                        {this.props.text}
                        {this.props.children}
                    </span>
                    <InputGroupAddon className="checkboxfield--box" addonType="append">
                        <Checkbox   className="checkboxfield--input" 
                                    bloqueado={this.props.bloqueado ? this.props.bloqueado : false}
                                    obrigatorio={this.props.disabled}
                                    onClick={this.handleClick}
                                    onChange={this.props.onChange}
                                    index={this.state.checkboxValue}
                                    ativo={this.props.ativo} 
                        />
                    </InputGroupAddon>
                    {this.props.showRequiredLabel && <span className="label-danger">*</span>}
                </InputGroupText>
                { (this.props.alerta && this.props.alerta.length > 0) && <Label className="label-danger">{ this.props.alerta }</Label> }
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/CheckboxField.js